<template>
  <div class="orderList">
    <div class="cartItem">
      <p class="requestAt mb5 notranslate">
        <i class="orderId">{{locale.order_id}} {{orderId}}</i>
        <span class="paymentStatus">
          {{orderStatus}}
        </span>
      </p>
      <div class="inner">
        <PaymentItem
          v-for="(item, index) in items"
          :key="index"
          :itemData="item"
          :locale="locale"
          :lang="lang"
          :noLink="true"
          class="itemInner" />
          <div class="payInfo notranslate">
            <span class="label">{{locale.payment_amount}}</span>
            <span class="value">{{priceFormat(paymentAmount)}}</span>
          </div>
          <div class="notranslate">
            <router-link
              :to="{name: 'paymentReceipt', params: {orderId: orderId}}"
              class="btn btnRound sizeS btnWhite toCapitalize btnReceipt">
              {{isPaid ? locale.card_receipt : locale.card_receipt_refunded}}
            </router-link>
          </div>
      </div>
    </div>
    <div class="sendEmail">
      <p>{{locale.payment_send_email}}</p>
      <form @submit.prevent="sendEmail">
        <div>
          <input
            v-model="send.email"
            type="email"
            placeholder="example@email.com"
            class="input"
            required>
        </div>
        <button type="submit" class="btn btnRoud btnFull">{{locale.send}}</button>
      </form>
    </div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'
import { DateTime } from 'luxon'
import PaymentItem from '@/components/Mypage/PaymentItem'

export default {
  name: 'PaymentItemPage',
  props: [
    'locale',
    'lang'
  ],
  components: {
    PaymentItem
  },
  computed: {
    orderId () {
      return this.$route.params.orderId
    },
    isPaid () {
      return this.type === 'paid'
    },
    orderStatus () {
      const isPaid = this.isPaid
      const status = isPaid ? this.locale.order_status_paid : this.locale.order_status_refunded
      return status
    },
    currencyCode () {
      return this.$store.getters['common/getSetting'].currency.toUpperCase()
    },
    format () {
      const setting = this.$store.state.common.setting
      const date = setting.dateFormat[setting.dateformatDefault]
      const time = 'HH:mm:ss'
      return `${date} ${time}`
    },
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    },
    paymentAmount () {
      const prices = this.items.map(x => x.price.info.total || 0)
      const sum = (a, b) => a + b
      return this.items.length ? prices.reduce(sum) : 0
      // return prices
    }
  },
  created () {
    const orderId = this.orderId
    this.$store.dispatch('payment/getReceipt', orderId).then((res) => {
      this.items = res.payload.length ? res.payload : [res.payload]
      this.type = res.type
    })
    this.send.url = window.location.href
  },
  data () {
    return {
      items: [],
      type: null,
      send: {
        url: '',
        email: ''
      }
    }
  },
  methods: {
    priceFormat (price) {
      const code = this.currencyCode
      return regExp.priceFormat(price, code)
    },
    datetimeFormat (iso) {
      const datetime = DateTime.fromISO(iso, { zone: this.timezone })
      return datetime.toFormat(this.format)
    },
    delItem (orderId) {
      if (window.confirm(this.locale.confirm_order_delete)) {
        this.$emit('deleteItem', orderId)
      }
    },
    sendEmail () {
      const data = {
        orderId: this.orderId,
        url: this.send.url,
        email: this.send.email
      }
      this.$store.dispatch('payment/sendEmailReceipt', data).then((res) => {
        if (res) {
          alert(this.locale.alert_complete_payment_send_email)
        } else {
          alert(this.locale.alert_system_error)
        }
      })
      this.send.email = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  .cartItem {
    margin: 15px;
  }
}
.sendEmail {
  position: relative;
  margin-top: 15px;
  padding: 30px 15px;
  text-align: center;
  border-top: 1px dashed $color-lgrey2;
  &:before,
  &:after {
    content: "";
    position: absolute;
    top: 0;
    margin-top: -10px;
    border-style: solid;
    border-width: 10px;
    border-color: transparent;
  }
  &:before {
    left: 0;
    border-left-color: $color-lgrey2;
  }
  &:after {
    right: 0;
    border-right-color: $color-lgrey2;
  }
  p {
    margin-bottom: 1em;
    font-size: 1.1em;
  }
  .btn {
    margin-top: 1em;
    border-radius: 4px;
  }
}
</style>
